import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { GAS_LIMIT, BUILDER_UNKNOWN, BUILDER_VANILLA, BLOCK_INFOS_API } from '../utils/constants.js';

const formatBlockLink = function (cell, formatterParams, onRendered) {
    const label = cell.getValue();
    const rowData = cell.getRow().getData();
    if (rowData.alimony === undefined) {
        return label
    }

    var link = window.location.origin + '/data/' + rowData.block;

    return `<a href="${link}">${label}</a>`;
};

const formatBuilderLink = function (cell, formatterParams, onRendered) {
    var label = cell.getValue();
    var rowData = cell.getRow().getData();
    if (label === BUILDER_UNKNOWN || label === "") {
        var firstFive = rowData.coinbase.slice(0, 5);
        var lastFive = rowData.coinbase.slice(-5);
        label = firstFive + "..." + lastFive;
    }
    if (rowData.coinbase === rowData.fee_recipient) {
        return label
    } else {
        const link = `https://etherscan.io/address/${rowData.coinbase}`;
        return `<a href="${link}" target="_blank" title="${rowData.coinbase}">${label}</a>`;
    }
};

const shortValidatorLink = function (cell, formatterParams, onRendered) {
    const address = cell.getValue();
    var rowData = cell.getRow().getData();
    var label = address;
    if (rowData.validator === undefined || rowData.validator === "") {
        if (label.length >= 10) {
            var firstFive = address.slice(0, 5);
            var lastFive = address.slice(-5);
            label = firstFive + "..." + lastFive;
        }
    } else {
        label = rowData.validator
    }
    const link = `https://etherscan.io/address/${address}`;

    return `<a href="${link}" target="_blank" title="${address}">${label}</a>`;
};


export default class BlockTableUI {

    constructor(element, block_infos, onBlockClick) {
        this.padding = { top: 0, right: 0, bottom: 0, left: 0 };
        this.onBlockClick = onBlockClick;
        var parentDiv = document.querySelector(element);
        var rect = parentDiv.getBoundingClientRect();
        this.height = rect.height;
        this.width = rect.width;
        this.append = true

        const handleBlockClick = (e, cell) => {
            const rowData = cell.getRow().getData();
            if (this.onBlockClick && rowData.block) {
                this.onBlockClick(rowData.block);
            }
        };

        this.table = new Tabulator(element, {
            layout: "fitColumns",
            height: this.height,
            responsiveLayout: "hide",
            maxHeight: "100%",
            rowFormatter: function (row) {
                row.getElement().style.height = "24px";
                row.getElement().style.backgroundColor = "#202124";
            },
            cellFormatter: function (cell) {
                cell.getElement().style.height = "24px";
            },
            columns: [
                { title: "Slot", field: "slot", sorter: "number", headerSort: true, hozAlign: "left", width: "80" },
                { title: "Block", field: "block", sorter: "number", headerSort: true, hozAlign: "left", width: "90", formatter: formatBlockLink, cellClick: handleBlockClick },
                { title: "Builder", field: "builder", sorter: "string", headerSort: true, hozAlign: "left", formatter: formatBuilderLink },
                { title: "Payout", field: "payout", sorter: "number", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left", width: "105" },
                { title: "Fees (B/P)", field: "fees", sorter: "string", headerSort: false, hozAlign: "left", width: "100" },
                { title: "Gas", field: "gas", sorter: "string", headerSort: false, hozAlign: "center", width: "50" },
                { title: "Validator", field: "fee_recipient", sorter: "string", headerSort: true, hozAlign: "left", formatter: shortValidatorLink, width: "160" },
                { title: "Payment", field: "payment", sorter: "number", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left", width: "105" },
                //{ title: "Missed", field: "missed", sorter: "string", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left", width: "105" },
                //{ title: "Offset", field: "offset", sorter: "string", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left" }
            ],
        });

        // Listen for the "tableBuilt" event
        this.table.on("tableBuilt", () => {
            this.setBlockInfos(block_infos)
        });

        this.table.on("dataSorted", (sorters, rows) => {
            if (sorters.length > 0) {
                this.disableAppend()
            }
        });

        this.setupFilter()
    }

    setBlockInfos = (block_infos) => {
        this.block_infos = block_infos
        this.setTableData(block_infos)
    }

    setTableData = (block_infos) => {
        var rows = []
        for (var i = block_infos.length - 1; i >= 0; i--) {
            var info = block_infos[i];
            rows.push(this.processBlockInfo(info))
        }
        this.table.setData(rows);
    }

    enableAppend = () => {
        this.append = true
    }

    disableAppend = () => {
        this.append = false
    }

    setupFilter = () => {
        var filterInput = document.getElementById('filter-input-block-table');
        var filterTimer;

        filterInput.addEventListener('input', () => {
            clearTimeout(filterTimer);
            filterTimer = setTimeout(() => {
                this.filter(filterInput.value.toLowerCase())
            }, 200); // Adjust the delay as desired (in milliseconds)
        });

        /*
        // add listener to reset button
        const resetButton = document.getElementById("reset-button-block");
        resetButton.addEventListener("click", () => {
            filterInput.value = ""
            // update table and history again
            fetch(BLOCK_INFOS_API) // fetch latest
                .then(response => response.json())
                .then(data => {
                    this.setBlockInfos(data)
                    this.enableAppend()
                    this.table.clearSort();
                })
                .catch(error => {
                    console.log(error)
                    this.setBlockInfos(this.block_infos)
                    this.enableAppend()
                });
        });
        */
    }

    filter = (str) => {
        var filteredBlocks;
        if (str !== "") {
            this.disableAppend()
            str = str.toLowerCase()
            filteredBlocks = this.block_infos.filter(block_info =>
                block_info.block === str || block_info.slot === str ||
                block_info.builder.toLowerCase().includes(str) ||
                block_info.coinbase.toLowerCase().includes(str) ||
                block_info.validator.toLowerCase().includes(str) ||
                block_info.fee_recipient.toLowerCase().includes(str)
            );
            this.setTableData(filteredBlocks)
        } else {
            this.setTableData(this.block_infos)
        }
    }

    newBlockSummary = (block_summary) => {
        if (this.append) {
            const rows = this.table.getRows();
            if (rows.length > 0) {
                if (block_summary.block === rows[0].getData().block + 1) {
                    this.table.addRow(this.processBlockSummary(block_summary), { insertBefore: rows[0] });
                } else {
                    this.block_summary = block_summary
                }
            } else {
                this.table.addRow(this.processBlockSummary(block_summary));
            }
        }
    }

    newBlockInfo = (block_info) => {
        if (this.append) {
            // TODO: check if block candle was clicked, if yes then do not add
            const fieldToMatch = "block"; // Replace 'fieldName' with the actual field name you want to match against
            const rows = this.table.getRows();
            const matchingRowIndex = rows.findIndex(row => row.getData()[fieldToMatch] === block_info.block);

            if (matchingRowIndex !== -1) {
                const matchingRow = rows[matchingRowIndex];
                // Add a new row with updated data at the same index
                this.table.addRow(this.processBlockInfo(block_info), true, matchingRow);
                matchingRow.delete();
                // Remove the matching row
            } else {
                if (rows.length > 0) {
                    if (block_info.block > rows[0].getData().block) {
                        this.table.addRow(this.processBlockInfo(block_info), { insertBefore: rows[0] });
                    }
                } else {
                    this.table.addRow(this.processBlockInfo(block_info));
                }
            }
            if (this.block_summary !== undefined) {
                this.newBlockSummary(this.block_summary)
            }
        }
    }

    processBlockSummary = (block_summary) => {
        var row = block_summary;
        // process block_summary
        row.fees = (block_summary.base_fee * 1e9).toFixed(0) + " | " + (block_summary.avg_gas_tip * 1e9).toFixed(1)

        var offset = (block_summary.timestamp / 1e6) - block_summary.winner.timestamp_ms
        if (offset > 0) {
            row.offset = "-" + offset / 1000 + "s"
            row.missed = (block_summary.best.value / 1e18 - block_summary.winner.value / 1e18).toFixed(8)
        } else {
            // winner was past slot time so probably delivered right
            row.offset = "-"
            row.missed = "-"
        }
        if (block_summary.winner.timestamp === 0) {
            // no winner existing
            row.offset = "-"
            if ((block_summary.best.value / 1e18 - block_summary.payment) > 0) {
                row.missed = (block_summary.best.value / 1e18 - block_summary.payment).toFixed(8)
            } else {
                row.missed = "-"
            }
        }
        if (block_summary.winner.timestamp === 0 && block_summary.best.timestamp === 0) {
            row.offset = "-"
            row.missed = "MEV"
        }

        if (block_summary.payout !== 0) {
            row.payout = block_summary.payout.toFixed(8)
        } else {
            row.payout = "-"
        }
        row.payment = block_summary.payment.toFixed(8)
        row.gas = (block_summary.gas_used / GAS_LIMIT * 100).toFixed(0) + "%"

        return row
    }

    processBlockInfo = (block_info) => {
        const row = { ...block_info };
        // process block_summary
        row.fees = (block_info.base_fee * 1e9).toFixed(0) + " | " + (block_info.prio_fee * 1e9).toFixed(1)

        var offset = -1 * block_info.offset
        if (offset > 0) {
            row.offset = "-" + offset / 1000 + "s"
            row.missed = (block_info.difference).toFixed(8)
        } else {
            // winner was past slot time so probably delivered right
            row.offset = "-"
            row.missed = "-"
        }
        if (offset === 0 && (block_info.builder.includes("geth") || block_info.builder.includes("linux"))) {
            // no winner existing
            row.offset = "-"
            if (block_info.difference > 0) {
                row.missed = (block_info.difference).toFixed(8)
            } else {
                row.missed = "-"
            }
        }
        if (block_info.builder === BUILDER_VANILLA) {
            row.offset = "-"
            row.missed = "MEV"
        }

        if (block_info.payout !== 0) {
            row.payout = block_info.payout.toFixed(8)
        } else {
            row.payout = "-"
        }
        row.payment = block_info.payment.toFixed(8)
        row.gas = (block_info.gas_used / GAS_LIMIT * 100).toFixed(0) + "%"

        return row
    }

    mockData = () => {
        const exampleData = [
            {
                slot: 6410146,
                block: 17231967,
                builder: "lightspeedbuilder",
                coinbase: "0xDAFEA492D9c6733ae3d56b7Ed1ADB60692c98Bc5",
                fees: "104 | 2.5",
                fee_recipient: "0x4675C7e5BaAFBFFbca748158bEcBA61ef3b0a263",
                payout: 0.15670568,
                payment: 0.15670568,
                missed: 0.00002366,
                offset: "-0.256s",
            },
            {
                slot: 6410145,
                block: 17231968,
                builder: "rsync-builder",
                coinbase: "0xDAFEA492D9c6733ae3d56b7Ed1ADB60692c98Bc5",
                fees: "99 | 1.1",
                fee_recipient: "0xb5d85cbf7cb3ee0d56b3bb207d5fc4b82f43f511",
                payout: 0.92643565,
                payment: 0.11677581,
                missed: 0.00007523,
                offset: "-0.119s",
            },
            {
                slot: 6410144,
                block: 17231969,
                builder: "spiderbuilder",
                coinbase: "0x690b9a9e9aa1c9db991c7721a92d351db4fac990",
                fees: "75 | 6.9",
                fee_recipient: "0x690b9a9e9aa1c9db991c7721a92d351db4fac990",
                payout: 0.00000000,
                payment: 0.51677544,
                missed: 0.00003571,
                offset: "-",
            },
            {
                slot: 6410143,
                block: 17231970,
                builder: "payload",
                coinbase: "0xCE0BaBc8398144Aa98D9210d595E3A9714910748",
                fees: "65 | 4.4",
                fee_recipient: "0x95222290DD7278Aa3Ddd389Cc1E1d165CC4BAfe5",
                payout: 0.00000000,
                payment: 0.55357544,
                missed: 0.00561199,
                offset: "-0.006s",
            },
        ];
        this.table.on("tableBuilt", function () {
            this.table.setData(exampleData);
        });
    }


}

/*
type BlockSummary struct {
    Slot         uint64          `json:"slot"`
    Block        uint64          `json:"block"`
    BlockHash    string          `json:"block_hash"`
    Builder      string          `json:"builder"`
    FeeRecipient string          `json:"fee_recipient"`
    Coinbase     string          `json:"coinbase"`
    Extra        string          `json:"extra"`
    Payout       float64         `json:"payout"`
    Payment      float64         `json:"payment"`
    Difference   float64         `json:"difference"`
    GasUsed      uint64          `json:"gas_used"`
    BaseFee      float64         `json:"base_fee"`
    AvgGasTip    float64         `json:"avg_gas_tip"`
    Best         BlockSubmission `json:"best"`
    Winner       BlockSubmission `json:"winner"`
    Timestamp    int64           `json:"timestamp"`
}
*/